
const AppConstants = {
  APP_NAME: 'Quizy',
  PLAY_GAME_TITLE: 'Play Game ?',
  VIEW_ALL_QUESTIONS: 'All Questions',
  ALL_QUESTIONS_TITLE: 'All Questions',
  ADD_NEW_QUESTION: 'Add Question',
  TIC_TAC_TOE_GAME_TITLE: 'Tic Tac Toe Game'
}

export default AppConstants;